let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bibJh")).then(() => parcelRequire('1hn1F'));